exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "dt[data-v-dd52cc34], dd[data-v-dd52cc34] {\n  margin-bottom: 20px;\n  display: inline-block;\n  vertical-align: middle;\n}\ndt[data-v-dd52cc34] {\n  min-width: 100px;\n  width: 30%;\n}\ndd[data-v-dd52cc34] {\n  width: 60%;\n}\n", ""]);
